export const NEW_UTK = ['newMessagesUtk'];
export const NEW_VID = ['newVid'];
export const THREAD_ID = ['threadId'];